/** Default layout ID for all layout sections */
export const DEFAULT_LAYOUT_ID = 'default';

export const OPTIONS_LAYOUT_ID = 'options-space';
export const OPTIONS_LAYOUT_TEMPLATE_ID = 'options-template';

export const CARE_ORDERS_LAYOUT_ID = 'care-orders-space';
export const CARE_ORDERS_LAYOUT_TEMPLATE_ID = CARE_ORDERS_LAYOUT_ID;

export const MANUAL_RFQS_LAYOUT_ID = 'manual-rfqs-space';
export const MANUAL_RFQS_LAYOUT_TEMPLATE_ID = MANUAL_RFQS_LAYOUT_ID;

export const ORDER_BOOKS_LAYOUT_ID = 'orderBooks';
export const ORDER_BOOKS_LAYOUT_TEMPLATE_ID = ORDER_BOOKS_LAYOUT_ID;

export const CHART_VIEWS_LAYOUT_ID = 'symbolViews';
export const CHART_VIEWS_LAYOUT_TEMPLATE_ID = CHART_VIEWS_LAYOUT_ID;

export const INTEL_OVERVIEW_LAYOUT_ID = 'overview';
export const INTEL_OVERVIEW_LAYOUT_TEMPLATE_ID = INTEL_OVERVIEW_LAYOUT_ID;

export const INTEL_LEADERBOARD_LAYOUT_ID = 'leaderboard';
export const INTEL_LEADERBOARD_LAYOUT_TEMPLATE_ID = INTEL_LEADERBOARD_LAYOUT_ID;

export const INTEL_FUNDING_RATES_LAYOUT_ID = 'funding-rate';
export const INTEL_FUNDING_RATES_LAYOUT_TEMPLATE_ID = INTEL_FUNDING_RATES_LAYOUT_ID;

export const DEALER_CUSTOMER_RISK_LAYOUT_ID = 'customer-risk';
export const DEALER_CUSTOMER_RISK_LAYOUT_TEMPLATE_ID = DEALER_CUSTOMER_RISK_LAYOUT_ID;

export const DEALER_EXECUTION_AND_PRICING_LAYOUT_ID = 'execution-and-pricing';
export const DEALER_EXECUTION_AND_PRICING_LAYOUT_TEMPLATE_ID = DEALER_EXECUTION_AND_PRICING_LAYOUT_ID;
